/** Top-level pages — drives the nav and the router. */
export interface PageDef {
  path: string;
  key: 'home' | 'about' | 'solutions' | 'impact' | 'ecosystem' | 'contact';
}

export const PAGES: readonly PageDef[] = [
  { path: '/', key: 'home' },
  { path: '/about', key: 'about' },
  { path: '/solutions', key: 'solutions' },
  { path: '/impact', key: 'impact' },
  { path: '/ecosystem', key: 'ecosystem' },
  { path: '/contact', key: 'contact' },
] as const;
